// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"17":"33ea7613","178":"a496a36b","241":"f0483f27","272":"082b7842","778":"1ee65885","839":"8cf5534a","896":"5ced045a","939":"823a068b"}[chunkId] + ".js";
};